import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;
let lastToken: string | null = null;

export function getSocketUrl(): string {
  return (process.env.REACT_APP_API_URI || "").replace(/\/$/, "");
}

export function getRealtimeSocket(): Socket | null {
  return socket;
}

/**
 * Connects to the VetNebula API Socket.io server (same origin as REACT_APP_API_URI).
 */
export function connectRealtimeSocket(token: string): Socket {
  if (socket?.connected && lastToken === token) {
    return socket;
  }
  lastToken = token;
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  socket = io(getSocketUrl(), {
    path: "/socket.io",
    auth: { token },
    transports: ["websocket", "polling"],
  });
  return socket;
}

export function disconnectRealtimeSocket(): void {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  lastToken = null;
}

/** Extra fields forwarded on `chat:message` for unread badges and UI sync. */
export type ChatPublishMeta = {
  senderId?: string;
  messageId?: string;
  unreadByChatId?: Record<string, number>;
};

/** Emit chat activity so other participants refetch (HTTP data still lives in Hasura/DB). */
export function publishChatActivity(
  chatId: string,
  notifyUserIds?: string[],
  meta?: ChatPublishMeta,
): void {
  const s = getRealtimeSocket();
  if (!s) return;
  const payload = {
    chatId,
    notifyUserIds,
    senderId: meta?.senderId,
    messageId: meta?.messageId,
    unreadByChatId: meta?.unreadByChatId,
  };
  const emit = () => s.emit("chat:publish", payload);
  if (s.connected) {
    emit();
  } else {
    s.once("connect", emit);
  }
}
